<template>
    <div class="main-panel">
        <div class="top-header">
            <div class="title">大数据可视化统计后台</div>
        </div>
        <div class="weather">
            <div style="width: 100%;height: 100%; position: absolute; z-index: 1001;"></div>
            <iframe width="240" scrolling="no" height="80" frameborder="0" allowtransparency="true" src="https://i.tianqi.com?c=code&id=35&color=%23FFFFFF&icon=1&site=34"></iframe>
        </div>
        <div class="timebox">{{nowTime}}</div>
        <div style="padding:20px;flex:1;position: relative;">
            <div class="flex-box">
                <div style="flex:3">
                    <div class="box">
                        <div class="angle1"></div>
                        <div class="angle2"></div>
                        <div class="inside-box">
                            <div class="bitem">
                                <div class="value">{{element.todayOrderCount}}</div>
                                <div class="label">今日订单数</div>
                            </div>
                            <div class="bitem">
                                <div class="value">{{element.todayLoginUserAdd}}</div>
                                <div class="label">今日新增用户</div>
                            </div>
                            <div class="bitem">
                                <div class="value">{{element.thisWeekOrderCount}}</div>
                                <div class="label">本周订单数</div>
                            </div>
                            <div class="bitem">
                                <div class="value">{{element.thisWeekLoginUserAdd}}</div>
                                <div class="label">本周新增用户</div>
                            </div>
                            <div class="bitem">
                                <div class="value">{{element.todayLoginUser}}</div>
                                <div class="label">今日活跃人数</div>
                            </div>
                            <div class="bitem">
                                <div class="value">{{element.yesterdayLoginUser}}</div>
                                <div class="label">昨日活跃人数</div>
                            </div>
                            <div class="bitem">
                                <div class="value">{{element.yesterdayOutUnit}}</div>
                                <div class="label">昨日出库量</div>
                            </div>
                            <div class="bitem">
                                <div class="value">{{element.yesterdayInUnit}}</div>
                                <div class="label">昨日入库量</div>
                            </div>
                            <div class="bitem">
                                <div class="value">{{element.yesterdayLogCount}}</div>
                                <div class="label">昨日操作条数</div>
                            </div>
                            <div class="bitem">
                                <div class="value">{{element.todayLogCount}}</div>
                                <div class="label">今日操作条数</div>
                            </div>
                            <div class="bitem">
                                <div class="value">{{element.yesterdayScanUnit}}</div>
                                <div class="label">昨日生产量</div>
                            </div>
                            <div class="bitem">
                                <div class="value">{{element.todayScanUnit}}</div>
                                <div class="label">今日生产量</div>
                            </div>
                            <div class="bitem">
                                <div class="value">{{element.yesterdayScanUnitAver}}</div>
                                <div class="label">昨日人均产量</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="flex:5;padding-bottom: 20px;" class="flex-sc-box">
                    <div class="box" style="flex:6">
                        <div class="box-title">地区监督统计</div>
                        <div class="angle1"></div>
                        <div class="angle2"></div>
                        <div id="box4" style="width:100%;height:100%"></div>
                    </div>
                    <div class="box" style="flex:6">
                        <div class="box-title">月度统计</div>
                        <el-date-picker size="mini" v-model="bValue5" class="box-month" @change="getInfo5" :clearable="false" type="monthrange" range-separator="至" value-format="yyyy-MM" format="yyyy-MM" style="width:180px" start-placeholder="开始月份" end-placeholder="结束月份">
                        </el-date-picker>
                        <div class="angle1"></div>
                        <div class="angle2"></div>
                        <div id="box5" style="width:100%;height:100%"></div>
                    </div>
                </div>
                <div style="flex:3" class="flex-sc-box">
                    <div class="box" style="flex:4">
                        <div class="box-title">操作日志趋势图</div>
						<el-date-picker class="box-month" v-model="bValue1" type="month" size="mini" format="yyyy-MM" :clearable="false" value-format="yyyy-MM" style="width:120px" @change="getInfo1" placeholder="选择月"></el-date-picker>
                        <div class="angle1"></div>
                        <div class="angle2"></div>
                        <div id="box1" style="width:100%;height:100%"></div>
                    </div>
                    <div class="box" style="flex:4">
                        <div class="box-title">活跃用户趋势图</div>
						<el-date-picker class="box-month" v-model="bValue2" type="month" size="mini" format="yyyy-MM" :clearable="false" value-format="yyyy-MM" style="width:120px" @change="getInfo2" placeholder="选择月"></el-date-picker>
                        <div class="angle1"></div>
                        <div class="angle2"></div>
                        <div id="box2" style="width:100%;height:100%"></div>
                    </div>
                    <div class="box" style="flex:3">
                        <div class="box-title">地区访问排名</div>
                        <el-date-picker class="box-month" v-model="bValue3" type="month" size="mini" format="yyyy-MM" :clearable="false" value-format="yyyy-MM" style="width:120px" @change="getInfo3" placeholder="选择月">
                        </el-date-picker>
                        <div class="angle1"></div>
                        <div class="angle2"></div>
                        <div id="box3" style="width:100%;height:100%"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from "echarts";
export default {
    data() {
        return {
            chartList: [null, null, null, null, null],
            nowTime: "",
            isShowPage: false,
            timer: null,
			bValue1: "",
			bValue2: "",
            bValue3: "",
            bValue5: "",
            element: {
                thisWeekLoginUserAdd: 0,
                thisWeekOrderCount: 0,
                todayLogCount: 0,
                todayLoginUser: 0,
                todayLoginUserAdd: 0,
                todayOrderCount: 0,
                todayScanUnit: 0,
                todayScanUnitAver: 0,
                yesterdayInUnit: 0,
                yesterdayLogCount: 0,
                yesterdayLoginUser: 0,
                yesterdayOutUnit: 0,
                yesterdayScanUnit: 0,
                yesterdayScanUnitAver: 0,
            },
        };
    },

    methods: {
        setResize() {
            this.chartList.forEach((e) => {
                if (e) {
                    e.resize();
                }
            });
        },
        close() {
            this.chartList.forEach((e) => {
                if (e && !e.isDisposed) {
                    e.dispose();
                }
            });
            this.isShowPage = false;
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        getMyChart(key) {
            let myChart = this.chartList[key];
            if (!myChart) {
                if (this.isShowPage) {
                    myChart = echarts.init(
                        document.getElementById("box" + (key + 1))
                    );
                    this.chartList[key] = myChart;
                }
            } else {
                myChart.clear();
            }
            return myChart;
        },
        init() {
            this.isShowPage = true;
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.nowTime = this.$common.formats(new Date());
            }, 1000);
            let date = new Date();
            let str2 =
                date.getFullYear() +
                "-" +
                ((date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1));
            date.setMonth(date.getMonth() - 6);
            let str1 =
                date.getFullYear() +
                "-" +
                ((date.getMonth() + 1 < 10 ? "0" : "") + (date.getMonth() + 1));
            this.bValue5 = [str1, str2];
			this.bValue1 = str2;
			this.bValue2 = str2;
            this.bValue3 = str2;
            this.getInfo0();
			this.getInfo1();
			this.getInfo2();
            this.getInfo3();
            this.getInfo5();
        },
        getInfo0() {
            this.$api.getGeneral().then((res) => {
                var keyList = Object.keys(this.element);
                keyList.forEach((e) => {
                    this.element[e] = res.data.data[e] ? res.data.data[e] : 0;
                });
            });
        },
        getInfo1() {
            var dd = null;
            let obj = {
                start: "",
                end: "",
            };
            if (this.bValue1) {
                dd = new Date(this.bValue1 + "-01");
            } else {
                dd = new Date();
                dd.setDate(1);
            }
            obj.start = this.$common.dayformat(dd);
            dd.setMonth(dd.getMonth() + 1);
            dd.setDate(0);
            obj.end = this.$common.dayformat(dd);
            this.$api.getLogCountGroupByDate(obj).then((res) => {
                let itemList = res.data.data.data;
                let myChart = this.getMyChart(0);
                if (myChart) {
                    let option = {
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "shadow",
                            },
                        },
                        legend: {
                            top: "top",
                            left: "100px",
							textStyle: {
                                color: "#02a6b5",
                            },
                            inactiveColor: "#d8e5e8",
                        },
                        grid: {
                            top: "20%",
                            left: "3%",
                            right: "3%",
                            bottom: "3%",
                            containLabel: true,
                        },
                        xAxis: {
                            type: "category",
                            data: itemList.map((e) => e.date),
							axisLabel: {
                                color: "#ffffff",
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#ffffff",
                                },
                            },
                        },
                        yAxis: {
                            type: "value",
                            splitNumber: 5,
							axisLabel: {
                                color: "#ffffff",
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#ffffff",
                                },
                            },
                        },
                        series: [
                            {
                                data: itemList.map((e) => e.count),
                                type: "bar",
                                type: "line",
                                smooth: true,
                                color: "#167FFC",
                            },
                        ],
                    };
                    myChart.setOption(option);
                }
            });
        },
        getInfo2() {
            var dd =null;
            let obj = {
                start:'',
                end:'',
            }
            if(this.bValue2){
                dd = new Date(this.bValue2+'-01');
                
            }else{
                dd = new Date();
                dd.setDate(1);
            }
            obj.start = this.$common.dayformat(dd);
            dd.setMonth(dd.getMonth()+1);
            dd.setDate(0);
            obj.end = this.$common.dayformat(dd);
            this.$api.getUserCountGroupByDate(obj).then(res=>{
                let itemList = res.data.data.data;
                let myChart = this.getMyChart(1);
                if(myChart){
                    let option = {
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "shadow"
                            }
                        },
                        legend: {
                            top: 'top',
                            left:"100px",
							textStyle: {
                                color: "#02a6b5",
                            },
                            inactiveColor: "#d8e5e8",
                        },
                        grid:{
                            top: '20%',
                            left: '3%',
                            right: '3%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: {
                            type: 'category',
                            data: itemList.map(e=>e.date),
							axisLabel: {
                                color: "#ffffff",
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#ffffff",
                                },
                            },
                        },
                        yAxis: {
                            type: 'value',
                            splitNumber:5,
							axisLabel: {
                                color: "#ffffff",
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#ffffff",
                                },
                            },
                        },
                        series: [
                            {
                                data: itemList.map(e=>e.count),
                                type: 'bar',
                                type: 'line',
                                smooth: true,
                                color:'#67C23A',
                            }
                        ]
                    };
                    myChart.setOption(option);
                }  
            })
        },
        getInfo3() {
            var dd = null;
            let obj = {
                start: "",
                end: "",
                top: 10,
            };
            if (this.bValue3) {
                dd = new Date(this.bValue3 + "-01");
            } else {
                dd = new Date();
                dd.setDate(1);
            }
            obj.start = this.$common.dayformat(dd);
            dd.setMonth(dd.getMonth() + 1);
            dd.setDate(0);
            obj.end = this.$common.dayformat(dd);
            this.$api.getTopIpProvince(obj).then((res) => {
                let itemList = res.data.data.data;
                let myChart = this.getMyChart(2);
                let arr = [];
                itemList.forEach((e) => {
                    arr.push({
                        name: e.country + e.province,
                        value: e.count,
                    });
                });
                if (myChart) {
                    let option = {
                        color: [
                            "#e50a2f",
                            "#409eff",
                            "#595bd4",
                            "#ebb563",
                            "#14d3a0",
                        ],
                        tooltip: {
                            trigger: "item",
                            formatter: "{a} <br/>{b} : {c} ({d}%)",
                        },
                        legend: {
                            orient: "vertical",
                            left: "left",
                            bottom: "10px",
                            textStyle: {
                                color: "#02a6b5",
                            },
                            inactiveColor: "#d8e5e8",
                        },
                        series: [
                            {
                                name: "地区",
                                type: "pie",
                                radius: ["40%", "70%"],
                                avoidLabelOverlap: false,
								label: {
									show: true,
									color: "#fff",
								},
                                emphasis: {
                                    label: {
                                        show: true,
                                        fontSize: 20,
										fontWeight: 'bold',
										color:'#fff',
                                    },
                                },
                                labelLine: {
                                    show: true,
                                },
                                data: arr,
                            },
                        ],
                    };
                    myChart.setOption(option);
                }
            });
        },
        getInfo5() {
            let myChart = this.getMyChart(4);
            if (this.bValue5 && this.bValue5.length == 2) {
            } else {
                return;
            }
            var obj = {
                start: this.bValue5[0],
                end: this.bValue5[1],
            };
            this.$api.getMonthData(obj).then((res) => {
                let data = res.data.data;
                if (myChart) {
                    let option = {
                        legend: {
                            left: "center",
                            textStyle: {
                                color: "#02a6b5",
                            },
                            inactiveColor: "#d8e5e8",
                            bottom: "10px",
                        },
                        tooltip: {
                            trigger: "axis",
                            axisPointer: {
                                type: "shadow",
                            },
                        },
                        grid: {
                            top: "20%",
                            left: "3%",
                            right: "3%",
                            bottom: "23%",
                            containLabel: true,
                        },
                        xAxis: {
                            type: "category",
                            data: data.month,
                            axisLabel: {
                                color: "#ffffff",
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#ffffff",
                                },
                            },
                        },
                        yAxis: {
                            type: "value",
                            axisLabel: {
                                color: "#ffffff",
                            },
                            axisLine: {
                                lineStyle: {
                                    color: "#ffffff",
                                },
                            },
                        },
                        series: [
                            {
                                data: data.monthOrder,
                                type: "bar",
                                name: "订单数",
                                label: {
                                    show: false,
                                },
                            },
                            {
                                data: data.monthSend,
                                type: "bar",
                                name: "发货数",
                                label: {
                                    show: false,
                                },
                            },
                            ,
                            {
                                data: data.monthIn,
                                type: "bar",
                                name: "入库数",
                                label: {
                                    show: false,
                                },
                            },
                            ,
                            {
                                data: data.monthOut,
                                type: "bar",
                                name: "出库数",
                                label: {
                                    show: false,
                                },
                            },
                            ,
                            {
                                data: data.monthProcess,
                                type: "line",
                                name: "扫码计件数",
                                smooth: true,
                                label: {
                                    show: false,
                                },
                            },
                            ,
                            {
                                data: data.monthManufacture,
                                type: "line",
                                name: "生产计件数",
                                smooth: true,
                                label: {
                                    show: false,
                                },
                            },
                        ],
                    };
                    myChart.setOption(option);
                }
            });
        },
        getInfo4() {
            
        },
    },
};
</script>
<style lang="scss" scoped>
.main-panel {
    width: 100%;
    min-width: 1024px;
    height: 100vh;
    min-height: 768px;
    background-color: #100b2b;
    position: absolute;
    color: #fff;
    top: 0px;
    left: 0px;
    display: flex;
    flex-direction: column;

    .top-header {
        width: 100%;
        height: 80px;
        text-align: center;
        position: relative;
        background: url("https://1178.shuntun.com/people-mediation-admin/profile/upload/2024/01/10/20240110154805A004.png");
        background-size: auto 120px;
        background-repeat: no-repeat;
        background-position: center;

        .title {
            line-height: 50px;
            font-size: 36px;
            font-weight: bold;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
        }
    }

    .weather {
        position: absolute;
        left: 20px;
        top: 10px;
    }

    .timebox {
        position: absolute;
        right: 20px;
        top: 10px;
        line-height: 80px;
        font-size: 18px;
    }
}

.box {
    border: 2px solid rgba(25, 186, 139, 0.17);
    padding: 10px;
    background: rgba(255, 255, 255, 0.04)
        url("https://1178.shuntun.com/people-mediation-admin/profile/upload/2024/01/11/20240111092602A010.png");
    background-size: 100% auto;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    height: 100%;
}
.box-title {
    position: absolute;
    font-size: 16px;
    color: #fff;
    padding: 0 10px;
    line-height: 20px;
    left: 5px;
    top: 10px;
}
.box-month {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 111;
}
.flex-box {
    display: flex;
    grid-gap: 20px;
    width: 100%;
    height: 100%;
    position: relative;
}

.flex-sc-box {
    display: flex;
    grid-gap: 10px;
    flex-direction: column;
}

.box::before {
    content: " ";
    position: absolute;
    width: 20px;
    height: 20px;
    border-bottom: 4px solid #6cfeff;
    border-left: 4px solid #6cfeff;
    left: 0px;
    bottom: 0px;
}

.box::after {
    content: " ";
    position: absolute;
    width: 20px;
    height: 20px;
    border-bottom: 4px solid #6cfeff;
    border-right: 4px solid #6cfeff;
    right: 0px;
    bottom: 0px;
}

.angle1 {
    position: absolute;
    width: 20px;
    height: 20px;
    border-top: 4px solid #6cfeff;
    border-left: 4px solid #6cfeff;
    left: 0px;
    top: 0px;
}

.angle2 {
    position: absolute;
    width: 20px;
    height: 20px;
    border-top: 4px solid #6cfeff;
    border-right: 4px solid #6cfeff;
    right: 0px;
    top: 0px;
}
.inside-box {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    position: relative;
}
.bitem {
    width: 100%;
    height: 40px;
    padding: 5px 0;
    background: linear-gradient(
        0deg,
        #0e42aa 0%,
        #002273 20%,
        #002273 80%,
        #0e42aa 100%
    );
    border: 2px solid #0e42aa;
    border-radius: 4px/25px;
    text-align: center;
    .label {
        line-height: 15px;
        font-size: 10px;
    }
    .value {
        line-height: 25px;
        font-size: 20px;
    }
}
</style>
